import React from 'react'
import SkeletonLoading from '../../pb_skeleton_loading/_skeleton_loading'

const SkeletonLoadingDefault = (props) => (
  <div>
    <SkeletonLoading {...props} />
  </div>
)

export default SkeletonLoadingDefault
